import * as actiontypes from '../types';
export const SellUsYourCarPageDetails = {
    state: {
        currentstep: 1,
        currentComponent: 'sellusyourcar-step-1',
        postdata: {
            anyMechanicalIssue: false,
            isAnAccidentCar: false,
            anyPaymentPending: false,
            question1_answer: false,
            question2_answer: false,
            question3_answer: false,
            currentMileage: '',
            zipCode: '',
            firstName: '',
            lastName: '',
            emailAddress: '',
            phoneNumber: '',
            comments:''
        },
        selluscarvin: '',
        scheduleInspection: {
            locationType: '',
            address: '',
            scheduleDateTime: '',
            selectedAddress: ''
        },
        userloginfirsttimecall: true,
        sellUsYourCarSettings: {},
        sellUsYourCarLeadSubmitted: false,
    },

    mutations: {
        incrementSellUsCarCurrentStep(state, payload) {
            state.currentstep++;
            if (state.currentstep === 7) {
                state.currentComponent = 'inspection-schedule-success';
            } else {
                state.currentComponent = 'sellusyourcar-step-' + state.currentstep;
            }

        },
        decrementSellUsCarCurrentStep(state, payload) {
            state.currentstep--;
            state.currentComponent = 'sellusyourcar-step-' + state.currentstep;
        },
        setSellUsCarCurrentStep(state, payload) {
            state.currentstep = payload;
            state.currentComponent = 'sellusyourcar-step-' + state.currentstep;
        },
        setSellUsCarInspectionSchedule(state) {
            state.currentComponent = 'inspection-schedule-success';
        },
        [actiontypes.SET_SELLUSYOURCAR_DATA](state, payload) {
            let postdata = state.postdata;

            let updatedPostdata = {...postdata, ...payload };
            state.postdata = updatedPostdata;
        },
        selluscarvin(state, payload) {
            state.selluscarvin = payload;
        },
        [actiontypes.SELL_US_CAR_INSPECTION_DELIVERY_DATA](state, payload) {
            state.scheduleInspection[payload['key']] = payload['value'];
        },
        userloginfirsttimecall(state, payload) {
            state.userloginfirsttimecall = payload;
        },
        getsellusyourcarsettings(state, payload) {
            state.sellUsYourCarSettings = payload;
        },
        sellUsYourCarLeadSubmitted(state, payload) {
            state.sellUsYourCarLeadSubmitted = payload;
        }
    },
    actions: {

    }
};
